module.exports = __webpack_public_path__ + "static/media/pokerPhone3.f9bd9406.svg";